import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

import Button from "../app/Button";
import { EVENT_NAMES, SCREEN_NAMES } from "src/helpers/analytics/events";
import analytics from "src/helpers/analytics";

interface UserTypeProps {
  title: string;
  description: string;
  value?: any;
  onBack: () => void;
  onNext: (userType: "patient" | "caregiver") => void;
  support_program_key?: string;
}

const UserType: React.FC<UserTypeProps> = ({
  title,
  description,
  value,
  onBack,
  onNext,
  support_program_key,
}) => {
  const [selected, setSelected] = useState<"patient" | "caregiver" | null>(
    value || null,
  );

  useEffect(() => {
    analytics.pageView(SCREEN_NAMES.USER_TYPE_SELECTION_SCREEN);
  }, []);

  const handleContinue = () => {
    if (selected) {
      // Event: USER_TYPE_SELECTED
      analytics.trackEvent(EVENT_NAMES.USER_TYPE_SELECTED, {
        user_type: selected,
        screen_name: SCREEN_NAMES.USER_TYPE_SELECTION_SCREEN,
        support_program_key: support_program_key,
      });
      onNext(selected);
    }
  };

  const options = [
    {
      value: "patient",
      title: "I am a patient",
      subtitle: "I am seeking medical care for myself",
    },
    {
      value: "caregiver",
      title: "I am a caregiver",
      subtitle: "I am helping someone else with their medical care",
    },
  ];

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="p-4 flex-1 min-h-0 overflow-y-auto">
        <button
          className="flex items-center gap-1 px-4 py-2 -ml-4"
          onClick={onBack}
        >
          <ArrowLeft className="w-4 h-4 text-gray-500" />
          <p className="text-sm text-gray-500">Back</p>
        </button>

        <div className="my-4">
          <h1 className="text-2xl font-bold text-[var(--text-primary)] mb-2">
            {title}
          </h1>
          <p className="text-[var(--text-secondary)]">{description}</p>
        </div>

        <div className="flex flex-col gap-4">
          {options.map((opt) => (
            <button
              key={opt.value}
              onClick={() => setSelected(opt.value as "patient" | "caregiver")}
              className={`w-full bg-white text-left border rounded-lg px-4 py-3 ${
                selected === opt.value
                  ? "border-[var(--app-primary)] bg-[var(--app-primary-bg)]"
                  : "border-gray-300"
              }`}
            >
              <p className="font-semibold text-[var(--text-primary)]">
                {opt.title}
              </p>
              <p className="text-sm text-[var(--text-secondary)]">
                {opt.subtitle}
              </p>
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white border-t border-gray-200 p-4 mt-auto">
        <Button
          fullWidth
          onClick={handleContinue}
          disabled={!selected}
          // className="mt-4"
        >
          <span className="flex items-center gap-2">
            Continue
            <ArrowRight className="w-4 h-4" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default UserType;
